export const safeGlobal = global;
//# sourceMappingURL=global.js.map